import React from 'react';
import { useCurrentUser } from '@marvelapp/marvel-3-application';
import MarvelTourJS from './index';
export default function MarvelTour() {
    const { role } = useCurrentUser();
    const showTours = false;
    if (!showTours || role === 'ANONYMOUS') {
        return null;
    }
    return React.createElement(MarvelTourJS, null);
}
